var map = {
	"./_ARK2882.jpg": 1140,
	"./_ARK2882_1.jpg": 1141,
	"./_ARK2885.jpg": 1142,
	"./_ARK2885_1.jpg": 1143,
	"./_ARK2984.jpg": 1144,
	"./_ARK2984_1.jpg": 1145,
	"./_ARK2986.jpg": 1146,
	"./_ARK2986_1.jpg": 1147,
	"./_ARK2987.jpg": 1148,
	"./_ARK2987_1.jpg": 1149,
	"./_ARK2991.jpg": 1150,
	"./_ARK2991_1.jpg": 1151
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 459;



//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Cafeteria ^\.\/.*\.jpg$
// module id = 459
// module chunks = 0